var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgListSvgrepoCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 1H1V3H3V1Z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 5H1V7H3V5Z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 9H3V11H1V9Z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 13H1V15H3V13Z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 1H5V3H15V1Z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 5H5V7H15V5Z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 9H15V11H5V9Z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 13H5V15H15V13Z",
    fill: "#ffffff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListSvgrepoCom);
export default __webpack_public_path__ + "static/media/list-svgrepo-com.af656689f5cffd5f0557d2ace6d8502d.svg";
export { ForwardRef as ReactComponent };